import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import OffersTable from "../../components/Tables/OffersTable";
import withPermissions from "../../components/WithPermissions";
import "./OfferManagement.css";
class Offers extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewOfferPermission = userPermissions.includes('new offer');
    return (
      <div
        className="offer-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Teklifler"
                Breadcrumb={[
                  {name: "Teklifler", navigate: ""},

                ]}
            />
            <section className="offer-hero">
              <div className="offer-hero-copy">
                <span className="offer-eyebrow"><i className="fa fa-circle" /> TEKLİF MERKEZİ</span>
                <h1>Tekliflerinizi tek yerden yönetin</h1>
                <p>Müşterilerinize hazırladığınız teklifleri görüntüleyin, durumlarını takip edin ve hızlıca yeni teklif oluşturun.</p>
              </div>
              {userHasNewOfferPermission && (
                <Link className="offer-hero-action" to="/offer-add">
                  <i className="fa fa-plus" /> Yeni teklif
                </Link>
              )}
            </section>
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card offer-list-panel">
                  <div className="header offer-panel-heading">
                    <div>
                      <span>TEKLİF KAYITLARI</span>
                      <h2>Tüm teklifler</h2>
                      <p>Teklif numarası, müşteri, tutar ve onay durumuna göre kayıtlarınızı yönetin.</p>
                    </div>
                  </div>
                  <div className="body">
                    <OffersTable />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Offers));
